<template>
  <article class="flex flex-col items-start">
    <div class="relative w-full">
      <NuxtLink 
      :to="$localePath(`/${type === 'webinar' ? 'webinars' : 'articles' }/${article.slug}`)"
      :aria-label="article.title"
      >
        <ImageResponsive
        v-if="article?.image && size === 'feature'"
        classes="rounded"
        :lazy="true"
        :data="article?.image"
        :xs="12"
        :sm="6"
        :md="7"
        :lg="7"
        :xl="7"
        />
        <ImageResponsive
        v-else-if="article?.image"
        classes="rounded"
        :lazy="true"
        :data="article?.image"
        :xs="12"
        :sm="6"
        :md="4"
        :lg="4"
        :xl="4"
        />
      </NuxtLink>
    </div>
    <div class="max-w-xl mt-2 sm:mt-4">
      <div class="group relative">
        <NuxtLink :to="$localePath(`/${type === 'webinar' ? 'webinars' : 'articles' }/${article.slug}`)">
          <h3 
          class="text-md font-semibold leading-6 md:leading-6 text-gray-900"
          :class="[ size == 'feature' ? 'md:text-xl' : 'md:text-md lg:text-lg' ]"
          >
            {{ article.title }}
          </h3>
          <div class="mt-2 flex items-center gap-x-4 text-xs">
            <time :datetime="article.date" class="text-gray-500">{{ formattedDate(article.date) }}<template v-if="article.time">, {{ article.time }} {{ useAustralianTimezone(article.date) }}</template></time>
          </div>
        </NuxtLink>
      </div>
    </div>
  </article>
</template>

<script setup>
const props = defineProps({
  article: {
    type: Object,
    required: true
  },
  size: {
    type: String,
    default: null
  },
  type: {
    type: String,
    required: false,
    default: 'blog'
  }
})

const formattedDate = givenDate => {
  const date = new Date(givenDate);
  
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return `${monthNames[monthIndex]} ${day}, ${year}`;
}
</script>